import { useMemo } from "react"
import { useSelector } from "react-redux"
import { getCrossModuleFilterPermissions } from "utils/crossModuleFilterPermissions"

/**
 * Role + plan gates for cross-module filter/list API calls (Orders-style).
 */
const useCrossModuleFilterPermissions = () => {
  const { userRole, accountType, accountScope } = useSelector(
    state => state.Login || {}
  )

  return useMemo(
    () =>
      getCrossModuleFilterPermissions(userRole, accountType, accountScope),
    [userRole, accountType, accountScope]
  )
}

export default useCrossModuleFilterPermissions
